// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addon-details {
  padding: 12px;
  grid-template-columns: repeat(3, 1fr);
}

.addon-textarea {
  resize: none;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  padding-left: 15px;
  padding-top: 12px;
}

.delete-plan-button:hover {
  background-color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/createAddons/createAddons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC","sourcesContent":[".addon-details {\n  padding: 12px;\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.addon-textarea {\n  resize: none;\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  padding-left: 15px;\n  padding-top: 12px;\n}\n\n.delete-plan-button:hover {\n  background-color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
